export enum InvoiceActions {
  Request = 'Request invoice',
  Accepted = 'Accepted invoice',
  Rejected = 'Rejected invoice',
  Create = 'Create invoice',
  CreateFromForm = 'Create invoice from form',
  Reload = 'Reload invoice',
  ToggleLoading = 'Toggle loading invoice',
}
